// extracted by mini-css-extract-plugin
module.exports = {"fade-in":"classes_fade-in__2DSN7","fadeIn":"classes_fadeIn__hD57Q"};